import React from 'react'

function Footer() {

    const footerYear = new Date().getFullYear();

    return (
        <footer className='footer p-6 bg-teal-900 text-primary-content'>
            <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
                <p className="text-sm">{footerYear} Heartland Alliance LTD/GTE. All Rights Reserved</p>
                <nav aria-label="footer links">
                    <a href="/assessment" className="text-sm text-teal-200 hover:underline ml-2">HIV Risk Assessment</a>
                </nav>
            </div>
        </footer>
    )
}

export default Footer
